var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto"},[_c('table',{ref:"myTable",staticClass:"table table-bordered position-relative",attrs:{"width":"100%"}},[(_vm.isLoading)?_c('tr',[_vm._m(0)]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('td',{attrs:{"colspan":"7"}},[_c('div',{staticClass:"dot-loading mt-3"},[_c('ul',{staticClass:"loader-circle"},[_c('li'),_c('li'),_c('li')])])])
}]

export { render, staticRenderFns }